import React, { createContext, useContext, useState, useEffect } from 'react';

// Criar o contexto
const AIChatContext = createContext();

// Hook personalizado para usar o contexto
export const useAIChat = () => {
  const context = useContext(AIChatContext);
  if (!context) {
    throw new Error('useAIChat deve ser usado dentro de um AIChatProvider');
  }
  return context;
};

// Provider do contexto
export const AIChatProvider = ({ children }) => {
  // Estado para controlar a visibilidade do FloatingAIChat
  const [isVisible, setIsVisible] = useState(false);

  // Função para alternar a visibilidade
  const toggleVisibility = () => {
    setIsVisible(prev => !prev);
  };

  // Função para definir a visibilidade
  const setVisibility = (visible) => {
    setIsVisible(visible);
  };

  // Carregar preferência do localStorage na inicialização
  // useEffect(() => {
  //   const savedVisibility = localStorage.getItem('ai-chat-visible');
  //   if (savedVisibility !== null) {
  //     setIsVisible(JSON.parse(savedVisibility));
  //   }
  // }, []);

  // Salvar preferência no localStorage quando mudar
  useEffect(() => {
    localStorage.setItem('ai-chat-visible', JSON.stringify(isVisible));
  }, [isVisible]);

  // Valor do contexto
  const value = {
    isVisible,
    toggleVisibility,
    setVisibility
  };

  return (
    <AIChatContext.Provider value={value}>
      {children}
    </AIChatContext.Provider>
  );
};

export default AIChatContext;
